/**
 * 呼び出し元画面に返却する情報を格納するVO
 */
export class KYMW0600OutputModel {
  /** 関連Pコード（旧） */
  public relationPCodeOld: string = <string>'';

  /** 関連Pコード（新） */
  public relationPCodeNew: string = <string>'';
}
